import FilterableFileList from "../sitepackage/filterableFileList/FilterableFileList";
import HashArgumentHelper from "../sitepackage/filterableFileList/HashArgumentHelper";
import HashArgumentObserver from "../sitepackage/filterableFileList/HashArgumentObserver";
import MobileFilterOverlay from "../sitepackage/filterableFileList/MobileFilterOverlay";
import { onDomReady } from "../utils/on-dom-ready";

const filterTypes = {
  CATEGORY: "category",
  TAG: "tag",
};

onDomReady(() => {
  const fileListContainer = document.querySelector(
    ".tx_sitepackage_news_fileListContainer--news"
  );
  if (
    fileListContainer instanceof HTMLElement &&
    !fileListContainer.dataset.filelistinitialized
  ) {
    const fileList = new FilterableFileList(fileListContainer, {
      fileListSelector: ".tx_sitepackage_news-fileList",
      filterSets: [
        {
          container: ".tx_sitepackage_news_categoryContainer",
          type: "category",
        },
        {
          container: ".tx_sitepackage_news_tagContainer",
          type: "tag",
        },
      ],
      itemsSelector: ".tx_sitepackage_news--item",
      isotope: {
        transitionDuration: "0.2s",
      },
    });
    const hashArgumentHelper = new HashArgumentHelper(
      window.location,
      filterTypes.CATEGORY,
      filterTypes.TAG
    );
    hashArgumentHelper.convertLegacyUrl();

    const hashArgumentObserver = new HashArgumentObserver(hashArgumentHelper);

    const observers = [hashArgumentObserver];
    // Feature flag (dark launch): the new mobile filter is only enabled off-live
    // via the data-mobile-filter attribute rendered by the isLive ViewHelper.
    if (fileListContainer.dataset.mobileFilter === "1") {
      const mobileFilter = new MobileFilterOverlay(fileListContainer, {
        sheetSelector: ".news-filter-sheet",
        labels: {
          open: fileListContainer.dataset.filterLabelOpen || "",
          apply: fileListContainer.dataset.filterLabelApply || "",
          close: fileListContainer.dataset.filterLabelClose || "",
        },
        fileList,
      });
      observers.push(mobileFilter.createCountObserver());
    }

    fileList.init(observers).then(() => {
      const categoryFilter = hashArgumentHelper.getFilter(filterTypes.CATEGORY);
      if (categoryFilter !== null) {
        categoryFilter.forEach((filter) => {
          fileList.setFilterState(filterTypes.CATEGORY, filter, true, true);
        });
      }
      const tagFilter = hashArgumentHelper.getFilter(filterTypes.TAG);
      if (tagFilter !== null) {
        tagFilter.forEach((filter) => {
          fileList.setFilterState(filterTypes.TAG, filter, true, true);
        });
      }
    });
  }
});
